import {CTA} from '@volkswagen-onehub/components-core';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 16px;
  max-width: 358px;
  margin: 0 auto;
  height: 100%;
  overflow-y: scroll;
  overflow-x: hidden;
  padding-left: 16px;
  padding-right: 16px;
  padding-top: 90px;
`;

export const ContinueButton = styled(CTA)`
  background-color: #fff;
  color: #001e50;
  border: none;
  width: 100%;
`;
